import { render } from "./ReviewPeople.vue?vue&type=template&id=44ad47a8&scoped=true&ts=true"
import script from "./ReviewPeople.vue?vue&type=script&lang=ts"
export * from "./ReviewPeople.vue?vue&type=script&lang=ts"

import "./ReviewPeople.vue?vue&type=style&index=0&id=44ad47a8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ad47a8"]])

export default __exports__